export const API_BASE_URL = 'https://cleverdomizil.de/virtual_office/api/';
export const INVOICE_URL = 'https://cleverdomizil.de/virtual_office/public/uploads/';

// export const API_BASE_URL = 'https://cleverbackend/virtual_office/api/';
// export const INVOICE_URL = 'https://cleverbackend/virtual_office/public/uploads/';